import RightChevron from "../vectors/RightChevron";

export default function BreadcrumbSeparator() {
    return <span className="ml-8 mr-4 text-primary-blue"><RightChevron /></span>
}